import TagHumans from 'Config/authenticated/TagHumans';

const formatMetaTypes = (types) =>
    types.map((type) => ({
        label: TagHumans[type].label,
        value: type,
    }));

const getDefaultCategory = (categories) => {
    const defaultAlreadySet = categories.find((category) => category.is_default);
    return defaultAlreadySet ? defaultAlreadySet : categories[0];
};

const defaultIndividualDetails = () => {
    return {
        type: 'prospect',
        civility: 'mr',
        name: '',
        firstName: '',
        email: '',
        birthDate: null,
        contact: {
            phone: null,
            mobile: null,
            fax: null,
        },
    };
};

const defaultIndividualParamSettings = () => {
    return {
        rateCategory: {},
        note: '',
        social: {
            facebook: null,
            twitter: null,
            linkedin: null,
        },
        syncProviders: {
            mailchimp: { name: 'mailchimp', isSetup: false },
            mailjet: { name: 'mailjet', isSetup: false },
            simplemail: { name: 'simplemail', isSetup: false },
        },
        smartTags: [],
    };
};

const defaultIndividualAccountability = () => {
    return {
        tiers: '',
        purchase: '',
        auxiliary: '',
    };
};
const nullIfFalsy = (data) => (data ? data : null);

const persistIndividualShorten = (individual) => {
    const persistIndividual = {
        last_name: individual.name.trim(),
        first_name: nullIfFalsy(individual.forename),
        civility: individual.civility?.value || 'mr',
    };

    if (individual.created) {
        persistIndividual.type = individual.type;
    }
    return persistIndividual;
};

const persistIndividual = (state, getters) => {
    return {
        // Required
        type: state.details.type,
        last_name: state.details.name.trim(),
        // Optionnal Details
        first_name: nullIfFalsy(state.details.firstName),
        phone_number: nullIfFalsy(state.details.contact.phone),
        mobile_number: nullIfFalsy(state.details.contact.mobile),
        fax_number: nullIfFalsy(state.details.contact.fax),
        email: nullIfFalsy(state.details.email),
        // Accounting
        auxiliary_code:
            state.details.type === 'supplier' || state.details.type === 'client'
                ? nullIfFalsy(state.accountability.auxiliary)
                : null,
        accounting_code_id:
            state.details.type === 'supplier' || state.details.type === 'client'
                ? nullIfFalsy(getters.getTiersCodeID)
                : null,
        accounting_purchase_code_id:
            state.details.type === 'supplier' ? nullIfFalsy(getters.getPurchaseCodeID) : null,
        // Optionnal Side Params
        rate_category_id:
            state.details.type === 'supplier' ? null : state.paramsSettings.rateCategory.value,
        note: state.paramsSettings.note,
        social: {
            facebook: nullIfFalsy(state.paramsSettings.social.facebook),
            twitter: nullIfFalsy(state.paramsSettings.social.twitter),
            linkedin: nullIfFalsy(state.paramsSettings.social.linkedin),
        },
        sync: {
            mailchimp: state.paramsSettings.syncProviders.mailchimp.isSetup,
            mailjet: state.paramsSettings.syncProviders.mailjet.isSetup,
            simplemail: state.paramsSettings.syncProviders.simplemail.isSetup,
        },
    };
};

const getIndividualsMetadata = () => {
    return ApiClient.get('/individuals/metadata');
};
const createIndividual = (ndjson) => {
    return ApiBatchClient.post('/batch', {}, ndjson);
};

const getIndividualAddresses = (id) => {
    return ApiClient.get(`/individuals/${id}/addresses`);
};

const getAllIndividualAddresses = async (id) => {
    let data = [];
    let pagination = { offset: '', total: 0 };

    do {
        const response = (
            await ApiClient.get(`/individuals/${id}/addresses`, { offset: pagination.offset })
        ).data;
        pagination = response?.pagination ?? pagination;
        data = data.concat(response?.data ?? []);
    } while (data.length < pagination.total);
    return data;
};

const updateIndividual = (id, params = {}, data) => {
    return ApiClient.put(`/individuals/${id}`, params, data);
};

const createIndividualAddress = (id, address) => {
    return ApiClient.post(`/individuals/${id}/addresses`, {}, address);
};

const updateIndividualAddress = (id, address) => {
    return ApiClient.put(`/individuals/${id}/addresses/${address.id}`, {}, address);
};

export {
    persistIndividual,
    persistIndividualShorten,
    defaultIndividualDetails,
    defaultIndividualAccountability,
    defaultIndividualParamSettings,
    getDefaultCategory,
    formatMetaTypes,
    getIndividualsMetadata,
    createIndividual,
    getIndividualAddresses,
    updateIndividual,
    getAllIndividualAddresses,
    createIndividualAddress,
    updateIndividualAddress,
};
